import AuthStore from 'auth-store';
import { req } from 'react-reqq-lite';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import React, { useState, useCallback, useEffect } from 'react';

import analytics from 'utils/analytics';
import { useOpenBetaPromotionModal } from 'modules/common/hooks';

import * as c from '../constants';
import LoginForm from '../forms/LoginForm';
import LandingWrapper from '../wrappers/LandingWrapper';
import MultiFactorAuthForm from '../forms/MultiFactorAuthForm';

const Login = () => {
  const location = useLocation();
  const [isMFAEnabled, setIsMFAEnabled] = useState(false);
  const openBetaPromotionModal = useOpenBetaPromotionModal();

  const handleOnLogin = useCallback(
    (res) => {
      const { is_mfa_enabled = false } = res?.response?.data || {};
      if (
        !is_mfa_enabled &&
        localStorage.getItem('always_hide_beta_promotion') !== '1'
      )
        openBetaPromotionModal();
      if (is_mfa_enabled) setIsMFAEnabled(is_mfa_enabled);
      analytics.done('login');
    },
    [setIsMFAEnabled, openBetaPromotionModal]
  );

  const handleOnSessionExpires = useCallback(
    () => setIsMFAEnabled(false),
    [setIsMFAEnabled]
  );

  useEffect(() => {
    const { token, is_mfa_enabled, email_address, environment_type } =
      queryString.parse(location?.search) ?? {};
    if (token) {
      AuthStore.set('_token', token);
      req.set(c.AUTHENTICATION, {
        isAuthenticated: true,
      });
      return;
    }
    if (is_mfa_enabled === '1' && email_address) {
      AuthStore.set('_email', email_address);
      AuthStore.set('_env_type', environment_type);
      setIsMFAEnabled(true);
    }
  }, [location]);

  return (
    <LandingWrapper
      title="Sign in to you account"
      description="Welcome! Please enter your email and password"
    >
      {!isMFAEnabled ? (
        <LoginForm onLogin={handleOnLogin} />
      ) : (
        <MultiFactorAuthForm onSessionExpires={handleOnSessionExpires} />
      )}
    </LandingWrapper>
  );
};

export default Login;
